import Input from "components/Blocks/Forms/Input/Input";

export default Input;
